/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
	const updateCheckInterval = 60 * 1000;
	let serviceWorkerRegistration;
	let lastUpdateCheck = 0;
	let refreshing = false;
	const hadController = Boolean(navigator.serviceWorker?.controller);

	const checkForUpdates = () => {
		if (document.visibilityState !== 'visible') return;
		if (!serviceWorkerRegistration) return;
		if (Date.now() - lastUpdateCheck < updateCheckInterval) return;

		lastUpdateCheck = Date.now();
		serviceWorkerRegistration?.update?.().catch(error => {
			console.error('Error while checking service worker updates:', error);
		});
	};

	// 新版 Service Worker 接管既有頁面後只重載一次，讓 HTML、JS、CSS
	// 全部切換到同一版 precache manifest。
	navigator.serviceWorker?.addEventListener('controllerchange', () => {
		if (!hadController || refreshing) return;

		refreshing = true;
		window.location.reload();
	});

	document.addEventListener('visibilitychange', checkForUpdates);

	register(`${process.env.BASE_URL}service-worker.js`, {
		registrationOptions: {
			// Service Worker 與其 importScripts 每次更新都直接向主機驗證。
			updateViaCache: 'none',
		},
		ready() {
			console.log(
				'App is being served from cache by a service worker.\n' +
					'For more details, visit https://goo.gl/AFskqB'
			);
		},
		registered(registration) {
			serviceWorkerRegistration = registration;
			checkForUpdates();
			console.log('Service worker has been registered.');
		},
		cached() {
			console.log('Content has been cached for offline use.');
		},
		updatefound() {
			console.log('New content is downloading.');
		},
		updated() {
			console.log('New content is available; activating update.');
		},
		offline() {
			console.log(
				'No internet connection found. App is running in offline mode.'
			);
		},
		error(error) {
			console.error('Error during service worker registration:', error);
		},
	});
}
